import {
    HOUR,
    DAY,
} from 'commons/js/constants'
import messages from './messages'

export function getTimeUnitMessage (timeUnit) {
    if (timeUnit === HOUR) {
        return messages.hourTimeUnit
    }
    if (timeUnit === DAY) {
        return messages.day
    }
    return null
}
